export default "__VITE_ASSET__DiA5JAmw__"